module.exports = __webpack_public_path__ + "static/img/03125.6841f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/editor/03125.png
// module id = b08L
// module chunks = 3